module.exports = __webpack_public_path__ + "img/img_bk.e04473a2.png";